import React from "react";
import userApi from "src/utils/axios";
import ConfigData from "./../../../../config/constant.json";
import LoadingScreen from "src/views/shared/Loading";
import { CCard, CCol, CRow } from "@coreui/react";
import {
  CTable,
  CTableHead,
  CTableBody,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CFormSwitch,
} from "@coreui/react";
import DeleteDailog from "../DeleteDailog";
import EditBatch from "./EditBatch";
import AddBatch from "./AddBatch";
import { Link } from "react-router-dom";
import CardHeader from "@mui/material/CardHeader";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";

import Fade from "@mui/material/Fade";
import moment from "moment";
import ScheduleMeeting from "./Meeting/ScheduleMeeting";
import ViewScheduledMeetings from "./Meeting/ViewScheduledMeetings";
import { useHistory } from "react-router-dom";

const Batch = (props) => {
  const history = useHistory();
  const [batch, setBatch] = React.useState("");
  const [batchId, setBatchId] = React.useState("");
  const [deleteDailog, setDeleteDailog] = React.useState(false);
  const [editDailog, setEditDailog] = React.useState(false);
  const [batchIndex, setBatchIndex] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  const courseId = props.courseId;
  const instituteId = props.instituteId;
  const instituteName = props.instituteName;
  const published = props.published;
  const [batchData, setBatchData] = React.useState([]);
  const [visible, setVisible] = React.useState(false);
  const [viewMeet, setViewMeet] = React.useState(false);
  const [role, setRole] = React.useState(true);

  // New card menu item states & function
  const [openIndex, setOpenIndex] = React.useState(-1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (index) => (event) => {
    setAnchorEl(event.currentTarget);
    setOpenIndex(index); // set current menu index to open
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    const userRoles = localStorage.getItem("role");
    if (userRoles === "VIEWER" || userRoles === "TEACHER") {
      setRole(false);
    } else {
      setRole(true);
    }
  }, []);

  React.useEffect(() => {
    getBatch();
  }, []);

  const getBatch = async () => {
    try {
      setLoading(true);
      let response = await userApi.post(
        `${ConfigData.SERVER_URL}/admin/batch/getbatch`,
        { courseId }
      );
      if (response.data.status == false) {
        throw Error(response.data.message);
      }
      setBatch(response.data.data);
      setLoading(false);
    } catch (e) {
      setError(`${e.message} :(`);
      setLoading(false);
    }
  };



  const isDisable = async (value, id) => {
    
    try {
      let response = await userApi.post(
        `${ConfigData.SERVER_URL}/admin/batch/isdisabled`,
        { isDisable: value, id: id }
      );


      if (!response.data.status == true) {
        throw Error("Something went wrong");
      }
      let toast = {
        status: true,
        body: response.data.message,
        message: "Success",
      };
      props.addToaster(toast);
    } catch (e) {
      let toast = {
        status: false,
        body: e.message,
        message: "Failed",
      };
      props.addToaster(toast);
    }
  };

  const isPublished = async (value, id) => {
    try {
      let response = await userApi.post(
        `${ConfigData.SERVER_URL}/admin/batch/ispublished`,
        { isPublished: value, id: id }
      );
      if (!response.data.status == true) {
        throw Error("Something went wrong");
      }
      let toast = {
        status: true,
        body: response.data.message,
        message: "Success",
      };
      props.addToaster(toast);
    } catch (e) {
      let toast = {
        status: false,
        body: e.message,
        message: "Failed",
      };
      props.addToaster(toast);
    }
  };

  const handleDelete = async (id) => {
    try {
      let response = await userApi.post(
        `${ConfigData.SERVER_URL}/admin/batch/deleteBatch`,
        { batchId }
      );
      if (response.data.status == false) {
        throw Error(response.data.message);
      }
      setBatch(
        batch.filter((item) => {
          return item._id != batchId;
        })
      );
      setDeleteDailog(false);
      let toast = {
        status: true,
        body: "deleted successfully",
        message: "Success",
      };

      props.addToaster(toast);
    } catch (e) {
      let toast = {
        status: false,
        body: e.message,
        message: "Failed",
      };

      props.addToaster(toast);
    }
  };

  let deleteBatch = (option) => {
    setBatchId(option._id);
    setDeleteDailog(true);
  };

  const editbatchCallback = (newbatch) => {
    let currentArray = [...batch];
    let changedArray = { ...(currentArray[batchIndex] = newbatch) };
    changedArray[batchIndex] = currentArray;
    setBatch(currentArray);
  };

  let editBatch = (option, index) => {
    setBatchId(option);
    setBatchIndex(index);
    setEditDailog(true);
  };

  let handleispublished = (option, index, _id) => {
    isPublished(option, _id);
    let curentArray = [...batch];
    let changedArray = { ...(curentArray[index].isPublished = !option) };
    changedArray[index] = curentArray;
    setBatch(curentArray);
  };

  let handleisdisable = (option, index, _id) => {
    isDisable(option, _id);
    let curentArray = [...batch];
    let changedArray = { ...(curentArray[index].isDisable = !option) };
    changedArray[index] = curentArray;
    setBatch(curentArray);
  };

  let addbatchCallback = (newbatch) => {
    let tempArray = [...batch, newbatch];
    setBatch(tempArray);
  };

  const scheduleMeet = async (item) => {
    setBatchData(item);
    setVisible(true);
  };

  const viewMeets = (item) => {
    setBatchData(item);
    setViewMeet(true);
  };

  const handleViewClick = (option) => {
    history.push({
      pathname: "/pages/master/batch",
      state: {
        courseId: option.courseId,
        batchName: option.batchName,
        batchId: option._id,
        startDate: option.startDate,
        endDate: option.endDate,
        batchFees: option.batchFees,
        instituteId: instituteId,
        instituteName: instituteName,
        published: published,
      },
    });
  };
  return (
    <>
      {batch.length > 0 && <h4>Available Batch:-</h4>}
      {batch.length <= 0 && <h3>Please add batches ....</h3>}
      <CRow>
        {loading && <LoadingScreen></LoadingScreen>}
        {
          <CTable striped hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell>Batch Name</CTableHeaderCell>
                {/* <CTableHeaderCell >Published</CTableHeaderCell> */}
                <CTableHeaderCell>In House Fees</CTableHeaderCell>
                <CTableHeaderCell>Outer Student Fees</CTableHeaderCell>
                <CTableHeaderCell>Teacher Fees</CTableHeaderCell>
                {/* <CTableHeaderCell >Is Featured</CTableHeaderCell> */}
                <CTableHeaderCell>Start Date</CTableHeaderCell>
                <CTableHeaderCell>End Date</CTableHeaderCell>

                <CTableHeaderCell>Registration Start Date</CTableHeaderCell>
                <CTableHeaderCell>Registration End Date</CTableHeaderCell>

                <CTableHeaderCell>Actions</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {batch &&
                batch.length > 0 &&
                batch.map((option, index) => (
                  <CTableRow key={index}>
                    <CTableDataCell>
                   {option.batchName}
                    </CTableDataCell>
                    {/* <CTableDataCell>
                               <CFormSwitch
                                 id={`flexSwitchCheck${index}`}
                                 checked={option.isPublished}
                                 onChange={() => handleispublished(option.isPublished, index, option._id)}
                               />
                             </CTableDataCell> */}
                    <CTableDataCell>
                      {option.isInHouse ? (
                        option.inHousePayment === "paid" ? (
                          <div>
                            <b>₹{option.inHouseFees}</b>
                          </div>
                        ) : option.inHousePayment === "free" ? (
                          <div>
                            <b>Free</b>
                          </div>
                        ) : (
                          <div>
                            <b>-NA-</b>
                          </div>
                        )
                      ) : (
                        <div>
                          <b>-NA-</b>
                        </div>
                      )}
                    </CTableDataCell>

                    <CTableDataCell>
                      {option.isInHouse ? (
                        option.outHousePayment === "paid" ? (
                          <div>
                            <b>₹{option.outHouseFees}</b>
                          </div>
                        ) : option.outHousePayment === "free" ? (
                          <div>
                            <b>Free</b>
                          </div>
                        ) : (
                          <div>
                            <b>-NA-</b>
                          </div>
                        )
                      ) : (
                        <div>
                          <b>-NA-</b>
                        </div>
                      )}
                    </CTableDataCell>

                    <CTableDataCell>
                      {option.isTeacher ? (
                        option.teacherPayment === "paid" ? (
                          <div>
                            <b>₹{option.teacherFees}</b>
                          </div>
                        ) : option.teacherPayment === "free" ? (
                          <div>
                            <b>Free</b>
                          </div>
                        ) : (
                          <div>
                            <b>-NA-</b>
                          </div>
                        )
                      ) : (
                        <div>
                          <b>-NA-</b>
                        </div>
                      )}
                    </CTableDataCell>

                    {/* <CTableDataCell>
                               <b>{option.isFeatured.toString().toUpperCase()}</b>
                             </CTableDataCell> */}
                    <CTableDataCell>
                      {moment(option.startDate).format("DD-MMM-YYYY")}
                    </CTableDataCell>
                    <CTableDataCell>
                      {moment(option.endDate).format("DD-MMM-YYYY")}
                    </CTableDataCell>
                    <CTableDataCell>
                      {moment(option.registrationStartDate).format(
                        "DD-MMM-YYYY"
                      )}
                    </CTableDataCell>

                    <CTableDataCell>
                      {moment(option.registrationEndDate).format("DD-MMM-YYYY")}
                    </CTableDataCell>
                    <CTableDataCell>
                      <IconButton
                        aria-label="settings"
                        onClick={handleClick(index)}
                      >
                        <MoreVertIcon />
                      </IconButton>
                      {role && (
                        <Menu
                          id="fade-menu"
                          anchorEl={anchorEl}
                          open={open && index === openIndex}
                          onClose={handleClose}
                          TransitionComponent={Fade}
                        >
                          <MenuItem
                            onClick={() => {
                              editBatch(option, index);
                              setAnchorEl(null);
                            }}
                          >
                            Edit
                          </MenuItem>
                          {/* <MenuItem onClick={() => { deleteBatch(option); setAnchorEl(null); }}>Delete Batch</MenuItem> */}
                          <MenuItem
                          onClick={()=>handleViewClick(option)}
                          >
                            View
                          </MenuItem>
                          <Tooltip
                            title={
                              !option.isDisable
                                ? "Disable Batch"
                                : "Enable Batch"
                            }
                            placement="right"
                          >
                            <div style={{ padding: "0.5rem 1rem" }}>
                              <CFormSwitch
                                id={`flexSwitchCheck${index}`}
                                checked={option.isDisable !== true}
                                onChange={() =>
                                  handleisdisable(
                                    option.isDisable,
                                    index,
                                    option._id
                                  )
                                }
                                style={{ cursor: "pointer" }}
                              />
                            </div>
                          </Tooltip>
                        </Menu>
                      )}
                    </CTableDataCell>
                  </CTableRow>
                ))}
            </CTableBody>
          </CTable>
        }

        {props.visible && (
          <AddBatch
            visible={props.visible}
            onClose={props.onClose}
            addToaster={props.addToaster}
            addbatchCallback={addbatchCallback}
            courseId={props.courseId}
          />
        )}

        {editDailog && (
          <EditBatch
            visible={editDailog}
            onClose={() => setEditDailog(false)}
            addToaster={props.addToaster}
            editbatchCallback={editbatchCallback}
            courseId={props.courseId}
            batch={batchId}
            index={batchIndex}
          />
        )}

        {deleteDailog && (
          <DeleteDailog
            visible={deleteDailog}
            onClose={() => setDeleteDailog(false)}
            delete={handleDelete}
            // allDelete={handleAllDelete}
          />
        )}

        {visible && (
          <ScheduleMeeting
            visible={visible}
            onClose={() => setVisible(false)}
            data={batchData}
            addToaster={props.addToaster}
          />
        )}

        {viewMeet && (
          <ViewScheduledMeetings
            visible={viewMeet}
            onClose={() => setViewMeet(false)}
            data={batchData}
            addToaster={props.addToaster}
          />
        )}
      </CRow>
      {!loading && batch.length == 0 && !error && <h1> No Batch Added</h1>}
      {!loading && error && <h1>{error}</h1>}
    </>
  );
};

export default Batch;
